<template>
  <div class="width-100">
    <div
      class="sample-details-index"
      v-for="sample in tableKeysWithSamples"
      :key="sample.tableKey"
    >
      <h2 class="section-title">
        {{ $t('sampleDetails.title') }} - {{ sample.labSampleCode }} -
        {{ sample.productName }}
      </h2>

      <TableWrapper
        :table-columns="sampleDetailsColumns"
        :show-pagination="false"
        :table-key="sample.tableKey"
        row-key="tableId"
        @insertMeasuredValue="sampleDetailsMixin.openInsertMeasuredValue"
        @insertMeasuredValueBulk="
          sampleDetailsMixin.openInsertMeasuredValueBulk
        "
        @createTemperatureTrail="sampleDetailsMixin.openCreateTemperatureTrail"
        @enableRawData="sampleDetailsMixin.enableDisableRawData"
        @disableRawData="sampleDetailsMixin.enableDisableRawData"
      />
    </div>

    <insertMeasuredValues
      v-if="
        measuredValueModal &&
        selectedOperationId &&
        selectedSampleAnalysisId &&
        selectedSample
      "
      :sample-analysis-id="selectedSampleAnalysisId"
      :operationId="selectedOperationId"
      :current-values="currentValues"
      :currentOperation="currentOperation"
      :sample="selectedSample"
      @dialogClose="sampleDetailsMixin.handleDialogClose"
    />

    <insertMeasuredValuesBulk
      v-if="measuredValueModalBulk && selectedSample && selectedAnalysis"
      :sample="selectedSample"
      :analysis="selectedAnalysis"
      @dialogClose="sampleDetailsMixin.handleDialogClose"
    />

    <CreateTemperatureTrail
      v-if="temperatureTrailModal && temperatureTrailAnalysisIds.length > 0"
      :labSampleAnalysisIds="temperatureTrailAnalysisIds"
      @dialogClose="sampleDetailsMixin.handleDialogClose"
    />
  </div>
</template>

<script>
  import { mapActions } from 'vuex';

  import { samplesApi } from '@/api';
  import { sampleDetailsColumns } from '@/config';
  import sampleDetailsMixin from '@/mixins/sampleDetails';
  import TableWrapper from '@/components/TableWrapper.vue';

  import insertMeasuredValues from './insertMeasuredValues.vue';
  import InsertMeasuredValuesBulk from './insertMeasuredValuesBulk.vue';
  import CreateTemperatureTrail from './CreateTemperatureTrail.vue';

  export default {
    name: 'SampleDetails',
    components: {
      TableWrapper,
      insertMeasuredValues,
      InsertMeasuredValuesBulk,
      CreateTemperatureTrail,
    },
    data() {
      return {
        // Globals
        sampleDetailsColumns,
        tableKeysWithSamples: [],

        // Insert Measured Values
        selectedSampleAnalysisId: null,
        selectedOperationId: null,
        currentValues: null,
        currentOperation: null,
        measuredValueModal: false,

        // Insert Measured Values Bulk
        measuredValueModalBulk: false,
        selectedSample: null,
        selectedAnalysis: null,

        // Temperature trail
        temperatureTrailModal: false,
        temperatureTrailAnalysisIds: [],
      };
    },
    methods: {
      ...mapActions([
        'updateTableRows',
        'updateTableCount',
        'parseQueryStringStatus',
        'addTable',
      ]),
      async tableRows(sampleIds = null) {
        try {
          const indexResponse = await samplesApi.samplesAnalysesMultiple(
            sampleIds || this.$route.query.sampleIds
          );
          this.sampleDetailsMixin.prepareTableData(indexResponse);
        } catch (error) {
          this.$notify({
            showClose: true,
            type: 'error',
            message: error.response.data.error.message,
          });
        }
      },
    },
    created() {
      this.sampleDetailsMixin = sampleDetailsMixin(this);
      this.parseQueryStringStatus(this.$route.query);
      this.tableRows();
      // this.getSample();
    },
    beforeRouteUpdate(to, from, next) {
      this.parseQueryStringStatus(to.query);
      this.tableRows(to.query.sampleIds);
      // this.getSample(to.params.sampleId);
      next();
    },
  };
</script>

<style lang="scss">
  .sample-details-index {
    .section-title {
      margin: 30px 0;
    }

    .table-cell-labSampleAnalysisStatus {
      position: relative;

      @each $modifier, $map in $sample-analysis-statuses {
        &--#{$modifier} {
          & .cell {
            padding-left: 20px;
          }

          &:after {
            content: '';
            display: block;
            width: 10px;
            position: absolute;
            height: 100%;
            top: 0;
            left: 0;
            background: map-get($map, 'background');
          }
        }
      }
    }
  }
</style>
